import React, { useState, useEffect, useRef } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import useApp from '../../store/app/appContext';
import LogoWithCaptionBlue from '../../components/Logos/LogoWithCaptionBlue';
import LogoBlue from '../../components/Logos/LogoBlue';
import HomeIcon from '../../components/Icons/outline/HomeIcon';
import ScanIcon from '../../components/Icons/outline/ScanIcon';
import CalendarIcon from '../../components/Icons/outline/CalendarIcon';
import TreatmentIcon from '../../components/Icons/outline/TreatmentIcon';
import ChevronRight from '../../components/Icons/solid/ChevronRight';
import ChevronUp from '../../components/Icons/solid/ChevronUp';
import LogoutIcon from '../../components/Icons/outline/LogoutIcon';
import MenuIcon from '../../components/Icons/outline/MenuIcon';
import UserIcon from '../../components/Icons/outline/UserIcon';
import CogIcon from '../../components/Icons/outline/CogIcon';
import BellIcon from '../../components/Icons/outline/BellIcon'
import SearchField from '../../components/Inputs/SearchField';
import LibraryIcon from '../../components/Icons/outline/LibraryIcon';
import GlobeIcon from '../../components/Icons/outline/GlobeIcon';
import { COLORS, LOGO_SIZES } from '../../config';
import ProfilePicture from '../../components/App/ProfilePicture';
import NotificationsDropdown from './NotificationsDropdown';
import { DocumentTextIcon } from '@heroicons/react/outline'
import TemplateIcon from '../../components/Icons/outline/TemplateIcon';

function useForceUpdate() {
  const [value, setValue] = useState(0);
  return () => setValue(value + 1)
}

function SideNavBar({ children, title, subtitle }) {
  const { logout, appState: { userNotifications, user } } = useApp();
  const notificationsRef = useRef()
  const notificationsMobileRef = useRef()
  const subMenuRef = useRef()
  
  const forceUpdate = useForceUpdate(); //This enables be to rerender the component on demand
  const [showNotificationsDropdown, setShowNotificationsDropdown ]= useState(false)
  const [showNotificationsMobileDropdown, setShowNotificationsMobileDropdown ]= useState(false)

  const collapseMenu = JSON.parse(localStorage.getItem('collapseMenu'));
  const showMobileMenu = JSON.parse(localStorage.getItem('showMobileMenu'));
  const showSubmenu = JSON.parse(localStorage.getItem('showSubmenu'));
  const showNetworkManagerSubmenu = JSON.parse(localStorage.getItem('showNetworkManagerSubmenu'));

  useEffect(() => {
    document.addEventListener("mousedown", (e)=>{
      if ((showSubmenu) && subMenuRef.current && !subMenuRef.current.contains(e.target)) {
        setShowSubmenu(false);
      }
      if ((showNotificationsDropdown) && notificationsRef.current && !notificationsRef.current.contains(e.target)) {
        setShowNotificationsDropdown(false);
      }
      if ((showNotificationsMobileDropdown) && notificationsMobileRef.current && !notificationsMobileRef.current.contains(e.target)) {
        setShowNotificationsMobileDropdown(false);
      }
    })
  })


  const setCollapseMenu = (state) => {
    if (!collapseMenu) setShowNetworkManagerSubmenu(false);
    localStorage.setItem('collapseMenu', state)
    forceUpdate(); //rerendering the component to reflect local storage update
  }
  const setShowMobileMenu = (state) => {
    localStorage.setItem('showMobileMenu', state)
    forceUpdate();
  }
  const setShowSubmenu = (state) => {
    localStorage.setItem('showSubmenu', state)
    forceUpdate();
  }
  const setShowNetworkManagerSubmenu = (state) => {
    localStorage.setItem('showNetworkManagerSubmenu', state)
    forceUpdate();
  }

  useEffect(() => {
    if (collapseMenu) {
      setShowNetworkManagerSubmenu(false);
    }
    setShowSubmenu(false);
  
  }, [])
  
  const history = useHistory();
  const location = useLocation();
  const currentLocation = location.pathname;
  
  useEffect(() => {
    if (
      currentLocation === '/manage-patients' ||
      currentLocation === '/manage-partners' ||
      currentLocation === '/manage-clinics'
    );
  }, [currentLocation]);

  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  const toggleSubmenu = () => {
    setShowSubmenu(!showSubmenu);
  }

  const handleCollapseMenu = () => {
    setCollapseMenu(!collapseMenu);
  }

  const handleMobileMenu = () => {
    setShowMobileMenu(!showMobileMenu);
  }
  
  useEffect(() => {
    function handleResize() {
      if (window.innerWidth <= 1024) {
        if (collapseMenu) setCollapseMenu(false);
        if (showMobileMenu) setShowMobileMenu(false);
      }
    }
    window.addEventListener('resize', handleResize);
  });

  const handleNetworkClick = (link) => {
    if (collapseMenu) localStorage.setItem('showNetworkManagerSubmenu', false)
    history.push(link);
  }
  
  return (
    <div className="flex h-screen max-h-screen whitespace-nowrap ">
      <div
        className={`bg-white z-50 absolute ${
          !collapseMenu && "w-80 min-w-300"
        } inset-y-0 left-0 lg:static h-full flex flex-col p-4 transition duration-500 shadow-md transform ${
          showMobileMenu ? "translate-x-0" : "-translate-x-full"
        } lg:translate-x-0`}
      >
        <div
          onClick={handleCollapseMenu}
          className="hidden absolute w-10 h-10 bg-primary lg:flex justify-center items-center right-0 top-0 transform translate-x-full cursor-pointer"
        >
          <MenuIcon stroke="white" size="h-8 w-8" />
        </div>
        <div
          onClick={handleMobileMenu}
          className="absolute w-10 h-10 bg-primary flex justify-center items-center left-0 sm:left-auto sm:right-0 lg:hidden top-0 transform sm:translate-x-full cursor-pointer"
        >
          <MenuIcon stroke="white" size="h-8 w-8" />
        </div>
        {!collapseMenu && (
          <div className="my-8 mx-auto">
            <LogoWithCaptionBlue className={LOGO_SIZES.CAPTION.large} />
          </div>
        )}
        {collapseMenu && (
          <div className="mb-20 mt-4">
            <LogoBlue className={LOGO_SIZES.NO_CAPTION.small} />
          </div>
        )}
        <div className="grid grid-cols-1 gap-y-6 p-4 text-lg">
          {user.user_type === "patient" && (
            <>
              <div
                className={`flex items-center font-medium cursor-pointer ${
                  currentLocation.includes("/dashboard")
                    ? "text-primary"
                    : "text-secondary"
                } hover:text-primary`}
                onClick={() => history.push("/dashboard")}
              >
                <HomeIcon stroke={COLORS.colorPrimary} />
                {!collapseMenu && <span className="ml-8">Home</span>}
              </div>
              <div
                className={`flex items-center font-medium cursor-pointer ${
                  currentLocation.includes("/my-scans")
                    ? "text-primary"
                    : "text-secondary"
                } hover:text-primary`}
                onClick={() => history.push("/my-scans")}
              >
                <ScanIcon stroke={COLORS.colorPrimary} />
                {!collapseMenu && <span className="ml-8 ">My Scans</span>}
              </div>
              <div
                className={`flex items-center font-medium cursor-pointer ${
                  currentLocation.includes("/my-appointments")
                    ? "text-primary"
                    : "text-secondary"
                } hover:text-primary`}
                onClick={() => history.push("/my-appointments")}
              >
                <CalendarIcon stroke={COLORS.colorPrimary} />
                {!collapseMenu && (
                  <span className="ml-8 ">My Appointments</span>
                )}
              </div>
              <div
                className={`flex items-center font-medium cursor-pointer ${
                  currentLocation.includes("/my-treatments")
                    ? "text-primary"
                    : "text-secondary"
                } hover:text-primary`}
                onClick={() => history.push("/my-treatments")}
              >
                <TreatmentIcon stroke={COLORS.colorPrimary} />
                {!collapseMenu && <span className="ml-8 ">My Treatments</span>}
              </div>
            </>
          )}
          {user.user_type === "partner" && (
            <>
              <div
                className={`flex items-center font-medium cursor-pointer ${
                  currentLocation.includes("/dashboard")
                    ? "text-primary"
                    : "text-secondary"
                } hover:text-primary`}
                onClick={() => history.push("/dashboard")}
              >
                <HomeIcon stroke={COLORS.colorPrimary} />
                {!collapseMenu && <span className="ml-8">Home</span>}
              </div>
              <div
                className={`flex items-center font-medium cursor-pointer ${
                  currentLocation.includes("/my-invoices")
                    ? "text-primary"
                    : "text-secondary"
                } hover:text-primary`}
                onClick={() => history.push("/my-invoices")}
              >
                <DocumentTextIcon
                  className="w-6 h-6"
                  stroke={COLORS.colorPrimary}
                />
                {!collapseMenu && <span className="ml-8 ">My Invoices</span>}
              </div>
              <div
                className={`flex items-center font-medium cursor-pointer ${
                  currentLocation.includes("/my-appointments")
                    ? "text-primary"
                    : "text-secondary"
                } hover:text-primary`}
                onClick={() => history.push("/my-appointments")}
              >
                <CalendarIcon stroke={COLORS.colorPrimary} />
                {!collapseMenu && (
                  <span className="ml-8 ">My Appointments</span>
                )}
              </div>
              <div
                className={`flex items-center font-medium cursor-pointer ${
                  currentLocation.includes("/my-treatments")
                    ? "text-primary"
                    : "text-secondary"
                } hover:text-primary`}
                onClick={() => history.push("/my-treatments")}
              >
                <TreatmentIcon stroke={COLORS.colorPrimary} />
                {!collapseMenu && <span className="ml-8 ">My Treatments</span>}
              </div>
            </>
          )}
          {(user.user_type === "staff" || user.user_type === "root") && (
            <>
              <div
                className={`flex items-center font-medium cursor-pointer ${
                  currentLocation.includes("/dashboard")
                    ? "text-primary"
                    : "text-secondary"
                } hover:text-primary`}
                onClick={() => history.push("/dashboard")}
              >
                <HomeIcon stroke={COLORS.colorPrimary} />
                {!collapseMenu && <span className="ml-8">Home</span>}
              </div>
              <div
                className={`flex items-center relative font-medium cursor-pointer ${
                  showNetworkManagerSubmenu ? "text-primary" : "text-secondary"
                } hover:text-primary`}
                onClick={() =>
                  setShowNetworkManagerSubmenu(!showNetworkManagerSubmenu)
                }
              >
                <TemplateIcon stroke={COLORS.colorPrimary} />
                {!collapseMenu && (
                  <span className="ml-8 text-lg">Network manager</span>
                )}
                {showNetworkManagerSubmenu && collapseMenu && (
                  <div className="absolute transform text-base translate-x-10 grid grid-cols-1 w-48 p-4 shadow-md bg-white rounded gap-y-2 -my-3 mb-1 pl-6">
                    <div
                      className={`flex items-center font-medium cursor-pointer ${
                        currentLocation.includes("/manage-patients")
                          ? "text-primary"
                          : "text-secondary"
                      } hover:text-primary`}
                      onClick={() => handleNetworkClick("/manage-patients")}
                    >
                      <span>Manage patients</span>
                    </div>
                    <div
                      className={`flex items-center font-medium cursor-pointer ${
                        currentLocation.includes("/manage-partners")
                          ? "text-primary"
                          : "text-secondary"
                      } hover:text-primary`}
                      onClick={() => handleNetworkClick("/manage-partners")}
                    >
                      <span>Manage partners</span>
                    </div>
                    <div
                      className={`flex items-center font-medium cursor-pointer ${
                        currentLocation.includes("/manage-clinics")
                          ? "text-primary"
                          : "text-secondary"
                      } hover:text-primary`}
                      onClick={() => handleNetworkClick("/manage-clinics")}
                    >
                      <span>Manage clinics</span>
                    </div>
                    <div
                      className={`flex items-center font-medium cursor-pointer ${
                        currentLocation.includes("/manage-staff")
                          ? "text-primary"
                          : "text-secondary"
                      } hover:text-primary`}
                      onClick={() => handleNetworkClick("/manage-staff")}
                    >
                      <span>Manage staff</span>
                    </div>
                  </div>
                )}
              </div>
              {showNetworkManagerSubmenu && !collapseMenu && (
                <div className="grid grid-cols-1 text-base w-full gap-y-2 -my-3 mb-1 pl-6">
                  <div
                    className={`flex items-center  font-medium cursor-pointer ${
                      currentLocation.includes("/manage-patients")
                        ? "text-primary"
                        : "text-secondary"
                    } hover:text-primary`}
                    onClick={() => handleNetworkClick("/manage-patients")}
                  >
                    <span className="ml-8">Manage patients</span>
                  </div>
                  <div
                    className={`flex items-center font-medium cursor-pointer ${
                      currentLocation.includes("/manage-partners")
                        ? "text-primary"
                        : "text-secondary"
                    } hover:text-primary`}
                    onClick={() => handleNetworkClick("/manage-partners")}
                  >
                    <span className="ml-8">Manage partners</span>
                  </div>
                  <div
                    className={`flex items-center font-medium cursor-pointer ${
                      currentLocation.includes("/manage-clinics")
                        ? "text-primary"
                        : "text-secondary"
                    } hover:text-primary`}
                    onClick={() => handleNetworkClick("/manage-clinics")}
                  >
                    <span className="ml-8">Manage clinics</span>
                  </div>
                  <div
                    className={`flex items-center font-medium cursor-pointer ${
                      currentLocation.includes("/manage-staff")
                        ? "text-primary"
                        : "text-secondary"
                    } hover:text-primary`}
                    onClick={() => handleNetworkClick("/manage-staff")}
                  >
                    <span className="ml-8">Manage staff</span>
                  </div>
                </div>
              )}
              <div
                className={`flex items-center text-lg font-medium cursor-pointer ${
                  currentLocation.includes("/manage-treatments")
                    ? "text-primary"
                    : "text-secondary"
                } hover:text-primary`}
                onClick={() => history.push("/manage-treatments")}
              >
                <TreatmentIcon stroke={COLORS.colorPrimary} />
                {!collapseMenu && (
                  <span className="ml-8 ">Treatment manager</span>
                )}
              </div>
              <div
                className={`flex items-center text-lg font-medium cursor-pointer ${
                  currentLocation.includes("/manage-invoices")
                    ? "text-primary"
                    : "text-secondary"
                } hover:text-primary`}
                onClick={() => history.push("/manage-invoices")}
              >
                <LibraryIcon stroke={COLORS.colorPrimary} />
                {!collapseMenu && (
                  <span className="ml-8 ">Invoice manager</span>
                )}
              </div>
            </>
          )}
        </div>
        <div className="mt-auto">
          <div className="w-full border-t border-gray-300" />
          <div
            ref={subMenuRef}
            className={`py-4 flex ${
              collapseMenu ? "justify-center align-center" : "pl-4"
            } w-full cursor-pointer`}
            onClick={toggleSubmenu}
          >
            <ProfilePicture user={user} />
            {!collapseMenu && (
              <div className="flex justify-between flex-grow items-center">
                <div className="flex flex-col justify-center px-4">
                  <span className="text-secondary">{user.first_name}</span>
                  <span className="text-xs font-medium text-gray-400">
                    {capitalizeFirstLetter(user.user_type) + " account"}
                  </span>
                </div>
                {!showSubmenu && (
                  <ChevronRight
                    fill={COLORS.colorSecondary}
                    className="cursor-pointer"
                  />
                )}
                {showSubmenu && (
                  <ChevronUp
                    fill={COLORS.colorPrimary}
                    className="cursor-pointer"
                  />
                )}
              </div>
            )}
            {showSubmenu && (
              <div
                className={`absolute text-lg bottom-0 p-4  ${
                  collapseMenu ? "right-0" : "inset-x-0"
                } rounded shadow transform -translate-y-28 mx-4 xl:ml-12  ${
                  collapseMenu ? "" : "grid grid-cols-1 gap-y-2"
                } p-4 bg-white`}
              >
                <div
                  className={`flex items-center ${
                    currentLocation.includes("/account")
                      ? "text-primary"
                      : "text-secondary"
                  } hover:text-primary cursor-pointer ${
                    collapseMenu ? "mb-2" : ""
                  }`}
                  onClick={() => history.push("/account")}
                >
                  <UserIcon stroke={COLORS.colorPrimary} className={"flex"} />
                  {!collapseMenu && <span className="ml-8">Account</span>}
                </div>
                {/* <div className={`flex items-center ${currentLocation.includes('/settings') ? 'text-primary' : 'text-secondary'} hover:text-primary cursor-pointer ${collapseMenu ? 'mb-2' : ''}`} onClick={() => history.push('/settings')}>
                <CogIcon stroke={COLORS.colorPrimary} className={'flex'}/>
                {!collapseMenu && <span className='ml-8'>Settings</span>}
              </div> */}
                <div
                  className={`flex items-center text-secondary hover:text-primary cursor-pointer ${
                    collapseMenu ? "" : ""
                  }`}
                  onClick={() => history.push("/patient")}
                >
                  <GlobeIcon stroke={COLORS.colorPrimary} />
                  {!collapseMenu && (
                    <span className="ml-8">Back to website</span>
                  )}
                </div>
                <div
                  className={`flex items-center text-secondary hover:text-primary cursor-pointer ${
                    collapseMenu ? "" : ""
                  }`}
                  onClick={logout}
                >
                  <LogoutIcon stroke={COLORS.colorPrimary} />
                  {!collapseMenu && <span className="ml-8">Logout</span>}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="flex flex-col flex-grow overflow-x-scroll">
        <div className="hidden sm:flex items-center w-full flex-row-reverse p-4 pr-8">
          <div ref={notificationsRef} className="ml-2">
            <BellIcon
              className="cursor-pointer"
              notificationCount={userNotifications?.length}
              onClick={() =>
                setShowNotificationsDropdown(!showNotificationsDropdown)
              }
              stroke={COLORS.colorSecondary}
            />
            {showNotificationsDropdown && (
              <div className="absolute">
                <div className="relative mt-6 ml-4">
                  <NotificationsDropdown
                    onClose={() => setShowNotificationsDropdown(false)}
                  />
                </div>
              </div>
            )}
          </div>
          <div className="w-56">
            {/* Search functionality not included in MVP */}
            {/* <SearchField /> */}
          </div>
        </div>
        <div className="sm:hidden bg-white flex flex-col px-6 py-6">
          <div className="flex justify-between items-center">
            <div onClick={handleMobileMenu}>
              <MenuIcon stroke={COLORS.colorSecondary} size="h-8 w-8" />
            </div>
            <LogoWithCaptionBlue className={LOGO_SIZES.CAPTION.medium} />
            <div ref={notificationsMobileRef} className="relative">
              <BellIcon
                className="cursor-pointer"
                notificationCount={userNotifications?.length}
                onClick={() =>
                  setShowNotificationsMobileDropdown(
                    !showNotificationsMobileDropdown
                  )
                }
                stroke={COLORS.colorSecondary}
              />
              {showNotificationsMobileDropdown && (
                <div
                  className="absolute top-0 right-0 mr-8 mt-12"
                  style={{ width: "350px" }}
                >
                  <NotificationsDropdown
                    mobile
                    onClose={() => setShowNotificationsDropdown(false)}
                  />
                </div>
              )}
            </div>
          </div>
          <div className="w-full mt-6">
            {/* Search functionality not included in MVP */}
            {/* <SearchField /> */}
          </div>
        </div>
        <div className={`flex flex-col flex-grow overflow-y-scroll w-full`}>
          {title && (
            <>
              <div
                className={`${
                  collapseMenu ? "py-0 px-20" : "pt-4 pb-2 px-3 md:px-8"
                } text-4xl text-secondary ${!subtitle && "mb-8"}`}
              >
                {title}
              </div>
              {subtitle && (
                <div
                  className={`${
                    collapseMenu ? "py-0 px-20" : "pb-2 px-3 md:px-8"
                  } text-2xl text-gray-500 mb-8`}
                >
                  {subtitle}
                </div>
              )}
            </>
          )}
          <div
            className={`${
              collapseMenu ? "px-20" : "px-3 md:px-8"
            } pb-2 overflow-y-scroll flex-grow`}
          >
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}

export default SideNavBar